import React from 'react';

import { Title, Text, TitleProps, TextProps } from '@soluto-design/react';

import { Button, ButtonProps } from '@soluto-design/react';
import Rating, { RatingProps } from '../../atoms/Rating';

import cls from '@soluto-design/styles/cls';

export interface BlockTitleLargeProps {
    preTitle?: string;
    preTitleTag?: TextProps['component'];
    title: string;
    titleTag?: TitleProps['component'];
    rating?: RatingProps;
    description?: string;
    cta?: ButtonProps;
    ctaSecondary?: ButtonProps;
    heroProportions?: boolean;
    buttonSecondaryVariation?: boolean;
}

export default function BlockTitleLarge({
    preTitle,
    preTitleTag = 'p',
    title,
    titleTag = 'h2',
    rating,
    description,
    cta,
    ctaSecondary,
    heroProportions,
    buttonSecondaryVariation,
}: BlockTitleLargeProps) {
    return (
        <>
            {!!preTitle && (
                <Text
                    component={preTitleTag}
                    className="text-c100 font-regular text-text-primary pb-lg uppercase">
                    {preTitle}
                </Text>
            )}
            {!!title && (
                <Title
                    isHtml
                    component={titleTag}
                    className={cls(
                        'font-regular text-text-primary',
                        heroProportions ? 'text-h100 ' : 'text-h200 ',
                    )}>
                    {title}
                </Title>
            )}
            {!!rating && (
                <Rating
                    {...rating}
                    className={cls(heroProportions ? 'pt-8' : 'pt-16')}
                />
            )}
            {!!description && (
                <Text
                    isHtml
                    component="div"
                    className={cls(
                        'font-regular text-text-secondary mt-lg mb-xxl unordered-list-items text-spacers [&_ul]:!mt-lg blockquote-list-icon [&_blockquote]:!mt-lg',
                        heroProportions
                            ? 'text-b300 pr-32 md:pr-80'
                            : 'text-b200 md:pr-xxxl',
                    )}>
                    {description}
                </Text>
            )}
            <div
                className={cls(
                    'flex gap-gutter',
                    heroProportions && 'flex-col w-full md:flex-row',
                )}>
                {!!cta && <Button variant="primary" size="large" {...cta} />}
                {!!ctaSecondary && (
                    <Button
                        variant="secondary"
                        size="large"
                        {...ctaSecondary}
                        className={cls(
                            buttonSecondaryVariation && 'bg-background-primary',
                        )}
                    />
                )}
            </div>
        </>
    );
}
